import Recap  from "./Recap"
import StoryWithKeywords from "./StoryWithKeywords"
import PronounciationSummary from "./PronounciationSummary"
import Activities from "./Activities"
import Story from "./Story";
import Assessment from "./Assessment";

export const renderers = {
    "recap": Recap ,
    "story-with-keywords": StoryWithKeywords,
    "pronounciation-summary": PronounciationSummary,
    "assessment": Assessment,
    "story": Story,
    "activities": Activities
}